/**
 * @fileoverview POST handler for the "/ai_agent/dynamic_prompts/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { aiAgentDynamicPromptsAppGroupIdCacheKeys } from "./constants";
import type { PostAiAgentDynamicPromptsAppGroupIdProps, AiAgentDynamicPromptsAppGroupIdResult } from "./types";

export const postAiAgentDynamicPromptsAppGroupId = reactQueryMutationAdapter(
  aiAgentDynamicPromptsAppGroupIdCacheKeys,
  (props: PostAiAgentDynamicPromptsAppGroupIdProps): Promise<AiAgentDynamicPromptsAppGroupIdResult> => {
    return fetch(`/ai_agent/dynamic_prompts/${props.appGroupId}`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
